export const countCharactersOfText = (lines = []) => {
    return lines.reduce((count, line) => {
        return count + line.items.length;
    }, 0);
}

export const getActualSelection = (selection) => {
    let startLine = selection.selectionStart['line'];
    let startPosition = selection.selectionStart['position'];
    let endLine = selection.selectionEnd['line'];
    let endPosition = selection.selectionEnd['position'];

    if (startLine > endLine || (startLine == endLine && startPosition > endPosition)) {
        startLine = selection.selectionEnd['line'];
        startPosition = selection.selectionEnd['position'];
        endLine = selection.selectionStart['line'];
        endPosition = selection.selectionStart['position'];
    }

    return { startLine, startPosition, endLine, endPosition };
}

export const selectedCharacterCounter = (selection, lines = []) => {
    if (selection.selectionStart.line === selection.selectionEnd.line && selection.selectionStart.position === selection.selectionEnd.position) {
        return 0;
    }

    const { startLine, startPosition, endLine, endPosition } = getActualSelection(selection);

    if (startLine === endLine) {
        return endPosition - startPosition;
    }

    let count = 0;

    for (let i = startLine; i <= endLine; i++) {
        if (i === startLine) {
            count += lines[i].items.length - startPosition;
        } else if (i === endLine) {
            count += endPosition;
        } else {
            count += lines[i].items.length;
        }
    }

    return count;
}

export const characterCounter = (selection, lines = []) => {
    const count = countCharactersOfText(lines);
    const selectedCount = selectedCharacterCounter(selection, lines);

    return count - selectedCount;
}

export const cutHtmlTextBySymbolsCount = (lines, count) => {
    let charactersCount = count;
    const result = [];

    for(const line of lines) {
        if ((charactersCount - line.items.length) >= 0) {
            result.push(line);

            charactersCount -= line.items.length;

            continue;
        } else if (charactersCount > 0) {
            const copyLine = {...line};
            copyLine.items.splice(charactersCount, copyLine.items.length - 1);

            result.push(copyLine);

            break;
        }

        break;
    }

    return result;
}

export const MAX_SYMBOLS_IN_LINE = 85;

export const convertTextToLines = (text = '') => {
    const textArr = text.split('\n');

    return textArr.map(textLine => {
        return {
            bullettedList: false,
            alignment: 'left',
            enterExists: true,
            items: textLine.split('').map(symbol => ({ value: symbol }))
        };
    });
}

export const splitStringByMaxSymbols = (lines = [], align = 'left') => {
    const result = [...lines];

    for(let i = 0; i < result.length; i++) {
        const currentLine = result[i];

        if (currentLine.items.length > MAX_SYMBOLS_IN_LINE) {
            const lastIndex = getLastPositionByWords(currentLine, MAX_SYMBOLS_IN_LINE);
            const items = currentLine.items.slice(lastIndex, currentLine.items.length);
            const newLine = { bullettedList: false, align, enterExists: true, items };

            result.splice(i + 1, 0, newLine);
            currentLine.enterExists = false;
            currentLine.items = currentLine.items.slice(0, lastIndex);
        } else {
            currentLine.enterExists = true;
        }
    }

    return result;
}

export const getLastPositionByWords = (line, position) => {
    let result = line.items.length;

    if (line.items.length > position) {
        for(let i = position - 1; i > 0; i--) {
            if (line.items[i].value === ' ') {
                result = i + 1;
                break;
            }
        }

        if (result === line.items.length) {
            result = position;
        }
    }

    return result;
}

